import { memo } from "react";

const classLabels = {
  Lm_av: <strong>L̄m</strong>,
  L_uo: (
    <strong>
      U<sub>o</sub>
    </strong>
  ),
  L_ul: (
    <strong>
      U<sub>l</sub>
    </strong>
  ),
  fTI: (
    <strong>
      f<sub>TI</sub>
    </strong>
  ),
  Rei: (
    <strong>
      R<sub>EI</sub>
    </strong>
  ),
  E_uo: (
    <strong>
      U<sub>o</sub> (E)
    </strong>
  ),
  Em_av: <strong>Ēm</strong>,
  Em_min: (
    <strong>
      E<sub>min</sub>
    </strong>
  ),
  Evm_min: (
    <strong>
      E<sub>v,min</sub>
    </strong>
  ),
  Escm_min: (
    <strong>
      E<sub>sc,min</sub>
    </strong>
  ),
};

export type ClassLabelKey = keyof typeof classLabels;

type ClassLabelProps = {
  labelKey: ClassLabelKey;
}

const ClassLabelComponent = ({ labelKey }: ClassLabelProps) => classLabels[labelKey] || null;

ClassLabelComponent.displayName = "ClassLabel";

export const ClassLabel = memo(ClassLabelComponent);
